import { visitorTypes } from '../Domains/visitorTypes';
import { messagePermissions } from './messagePermissions';
import { payments } from './payments';

export class IBranch {
    _id                             : string;
    name                            : string;
    address                         : string;
    phone                           : string;
    status                          : string;
    contactPerson                   : string;
    type                            : string;
    contactPersonEmail              : string;
    company                         : string;
    appPassword                     : string;
    starttime                       : Date;
    endtime                         : Date;
    createdBy                       : string;
    gymPackage                      : string;
    modifiedBy                      : string;
    domain                          : string;
    isWhatsappEnabled               : boolean;
    isSmsEnabled                    : boolean;
    businessRule                    : boolean;
    visitorFee                      : string;
    shortAddress                    : string;
    whatsapp                        : string;
    whatsappCommunityInvitationLink : string;
    feeWhatsapp                     : string;
    visitorWhatsapp                 : string;
    registrationWhatsapp            : string;
    lockDefaulterOnACT              : boolean;
    generalTaxSettings              : GeneralTaxSettings;
    visitorTypes                    : visitorTypes;
    messagesPermission              : messagePermissions;
    payments                        : payments;
    userCount                        : number;
    termsAndConditions?             : string;
    isExportEnabled?                : boolean;
    invoiceData: {
        name: { type: String, trim: true },
        bannerImage: [{
            image: { type: String, trim: true },
        }
        ],
        address: { type: String, trim: true },
        contact: [{
            contactNumber: { type: String, trim: true },
        }
        ],
        invoiceMessage: { type: String, trim: true },
        showAddedBy:  boolean,
        showCustomerContact: boolean,
    }
    reportPrintData: {
        name: { type: String, trim: true },
        bannerImage: [{
            image: { type: String, trim: true },
        }
        ],
        address: { type: String, trim: true },
        contact: [{
            contactNumber: { type: String, trim: true },
        }
        ],
    }
    companyDetails: {
        bannerImage: {
            image: { type: String, trim: true },
        }
    }
    permissions: {
        invoiceWhatsAppMsg: boolean;
        isDiscountFormulaReverse: boolean;
        isAllowedWallet:boolean;
        isAllowSRB: boolean
        isAllowFBR: boolean
        isAllowWallet:boolean;
        hideMemberSettingFromOp:boolean;
        isAllowDashboardCharts:boolean;
        taxRemovalOnSubscription:boolean;
        complimentaryFreezingDays:boolean;
        hideSubFeeBtnFromOp:boolean;
        isImportFeeAllowed:boolean;
        genderSegregation?:boolean;
        isreferralSourceAllowed:boolean;
        allowOpExportReports:boolean;
        paymentModeTaxPos:boolean;
        allowToEditInvoiceDate:boolean;
        allowToEditPaymentMode:boolean;
        showQuotation?: boolean;
        timeBasedPackages?: boolean;
        liveAttendanceScreen?: boolean;
        expireMemberPriorOneDay?: boolean;
        trainerModule?: {
            enabled?: boolean;
            cancelEnabled?: boolean;
            cancelBeforeValue?: number;
            cancelBeforeUnit?: 'hours' | 'days';
            feeDeleteRoles?: string[];
        };
    }
    requiredFieldsCustomer?: {
        email?: boolean;
        dateOfBirth?: boolean;
        CNIC?: boolean;
        passport?: boolean;
    };
}

class GeneralTaxSettings {
    isTaxOnPayout: boolean;
    payoutTaxOnRate: number;
}